import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import Navigation from '../components/Navigation';
import './MyProjects.css';

function MyProjects() {
  const { userProfile } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userProfile?.chapterId) {
      fetchMyProjects();
    }
  }, [userProfile]);

  async function fetchMyProjects() {
    try {
      const q = query(
        collection(db, 'projects'),
        where('claimedBy', '==', userProfile.chapterId)
      );
      
      const querySnapshot = await getDocs(q);
      const projectsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setProjects(projectsList);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching my projects:', error);
      setLoading(false);
    }
  }

  return (
    <div className="projects-container">
      <Navigation />
      
      <div className="projects-content">
        <div className="projects-header">
          <h1>My Chapter's Projects</h1>
          <p>Projects claimed by your chapter</p>
        </div>

        {loading ? (
          <div className="loading">Loading your projects...</div>
        ) : projects.length === 0 ? (
          <div className="no-projects">
            <div className="empty-state">
              <h2>No Claimed Projects Yet</h2>
              <p>Your chapter hasn't claimed any projects yet.</p>
              <p>Visit the Available Projects page to claim a project!</p>
            </div>
          </div>
        ) : (
          <div className="projects-list">
            {projects.map(project => (
              <div key={project.id} className="my-project-card">
                <div className="project-card-header">
                  <h3>{project.title}</h3>
                  <span className="status-badge claimed">Claimed</span>
                </div>
                
                <p className="project-location">📍 {project.location}</p>
                <p className="project-category">{project.category}</p>
                
                <div className="project-description">
                  {project.description}
                </div>

                <div className="requirements-section">
                  <strong>Requirements:</strong>
                  <ul>
                    {project.requirements?.map((req, index) => (
                      <li key={index}>{req}</li>
                    ))}
                  </ul>
                </div>

                <div className="project-footer">
                  <span>⏱️ {project.estimatedHours} hours</span>
                  <span>📅 Claimed: {project.claimedDate?.toDate().toLocaleDateString()}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MyProjects;
